module.exports = __webpack_public_path__ + "static/doctor-9b00cdbac887530d2901a7e567cc75f4.svg";